var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"value-boxes-container"},_vm._l((_vm.data),function(item,index){return _c('value-box',{key:index,attrs:{"data":item}})}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }